import axios from 'axios'

const baseURL = process.env.VUE_APP_END_POINT_V1
const headers = { 'Content-Type': 'application/json' }

const instance = axios.create({
  baseURL,
  headers,
  timeout: 0,
  withCredentials: true,
  maxRedirects: 0
})

export default instance
